export const navigation = [
  {
    id: 'features',
    title: 'Features',
    type: 'group',
    priv: 'user',
    children: [
      {
        id: 'aptbook',
        title: 'Appointment Book',
        type: 'item',
        icon: 'event',
        url: '/frontoffice/aptbook',
        children: [],
        priv: 'user',
      },
      {
        id: 'queueManager',
        title: 'Queue Manager',
        type: 'item',
        icon: 'low_priority',
        url: '/frontoffice/queueManager',
        children: [],
        RequireTill: true,
        priv: 'user',
      },
      {
        id: 'general-sale',
        title: 'General Sale',
        type: 'item',
        icon: 'point_of_sale',
        url: '/frontoffice/pos',
        children: [],
        RequireTill: true,
        priv: 'user',
      },
      {
        id: 'vouchers',
        title: 'Vouchers',
        icon: 'redeem',
        type: 'item',
        url: '/frontoffice/vouchers',
        priv: 'User',
      },
      {
        id: 'amend-sale',
        title: 'Amend Sale',
        type: 'item',
        icon: 'payments',
        url: '/frontoffice/amendSale',
        children: [],
        RequireTill: true,
        priv: 'user',
      },
      {
        id: 'void-sale',
        title: 'Void Sale',
        type: 'item',
        icon: 'cancel_presentation',
        url: '/frontoffice/voidSale',
        children: [],
        RequireTill: true,
        priv: 'user',
      },
      {
        id: 'EOSRoutine',
        title: 'End of Shift',
        type: 'item',
        icon: 'task_alt',
        RequireTill: true,
        priv: 'user',
        function: (a) => {
          a.events.SendSystemCommand('CloseTill', null);
        },
      },
      {
        id: 'marketing',
        title: 'Marketing',
        type: 'collapse',
        icon: 'campaign',
        priv: 'Admin',
        children: [
          {
            id: 'automated-messages',
            title: 'Automated Messages',
            type: 'item',
            icon: 'schedule_send',
            url: '/marketingoffice/automated-messages',
            priv: 'Admin',
          },
          {
            id: 'campaigns',
            title: 'Campaigns',
            type: 'item',
            icon: 'construction',
            url: '/marketingoffice/campaigns',
            priv: 'Admin',
          },
          {
            id: 'marketing-settings',
            title: 'Marketing Settings',
            type: 'item',
            icon: 'settings',
            url: '/marketingoffice/marketing-settings',
            priv: 'Admin',
          },
          {
            id: 'message-history',
            title: 'Message History',
            type: 'item',
            icon: 'history',
            url: '/marketingoffice/message-history',
            priv: 'Admin',
          },
          {
            id: 'quick-message',
            title: 'Quick Message',
            type: 'item',
            icon: 'quickreply',
            url: '/marketingoffice/quick-message',
            priv: 'Admin',
          },
        ],
      },
      {
        id: 'reports',
        title: 'Reports',
        type: 'item',
        icon: 'summarize',
        priv: 'Admin',
        url: '/reportoffice/reports',
      },
      {
        id: 'employee_rota',
        title: 'Rota',
        icon: 'punch_clock',
        type: 'item',
        url: '/frontoffice/employee-rota',
        priv: 'user',
      },
      {
        id: 'systemMaintenance',
        title: 'System Maintenance',
        type: 'collapse',
        icon: 'build',
        priv: 'Admin',
        children: [
          {
            id: 'adjustcredits',
            title: 'Adjust Credits',
            type: 'item',
            icon: 'build_circle',
            url: '/frontoffice/adjustcredits',
            children: [],
            RequireTill: false,
            priv: 'Admin',
          },
          {
            id: 'appointmentViews',
            title: 'Appointment Views',
            type: 'item',
            icon: 'view_column',
            url: '/backoffice/appointment-views',
            priv: 'Admin',
          },
          {
            id: 'branches',
            title: 'Branches',
            type: 'item',
            icon: 'store',
            url: '/backoffice/branches',
            priv: 'Admin',
          },
          {
            id: 'clients',
            title: 'Clients',
            type: 'item',
            icon: 'people',
            url: '/backoffice/clients',
            priv: 'Admin',
          },
          {
            id: 'courses',
            title: 'Courses',
            icon: 'credit_card',
            type: 'item',
            url: '/backoffice/product-courses',
            priv: 'Admin',
          },
          {
            id: 'credit_systems',
            title: 'Credit Systems',
            type: 'item',
            icon: 'attach_money',
            url: '/backoffice/creditsystems',
            priv: 'Admin',
          },
          {
            id: 'customer-settings',
            title: 'Customer Settings',
            icon: 'tune',
            type: 'item',
            url: '/backoffice/customer-settings',
            priv: 'Admin',
          },
          {
            id: 'disclaimers',
            title: 'Disclaimers',
            icon: 'grading',
            type: 'item',
            url: '/backoffice/disclaimers',
            priv: 'Admin',
          },
          {
            id: 'discounts',
            title: 'Discounts',
            icon: 'percent',
            type: 'item',
            url: '/backoffice/discounts',
            priv: 'Admin',
          },
          {
            id: 'user_management',
            title: 'Employees',
            icon: 'face',
            type: 'item',
            url: '/backoffice/employees',
            priv: 'Admin',
          },
          {
            id: 'employee_rota_manager',
            title: 'Employee Rota Manager',
            icon: 'punch_clock',
            type: 'item',
            url: '/backoffice/employee-rota-manager',
            priv: 'Admin',
          },
          {
            id: 'resource-online-available-hours',
            title: 'Online Booking Availability',
            icon: 'phone_iphone',
            type: 'item',
            url: '/backoffice/resource-online-available-hours',
            priv: 'Admin',
          },
          {
            id: 'online-sales',
            title: 'Online Sales',
            icon: 'shopping_cart',
            type: 'item',
            url: '/backoffice/online-sales',
            priv: 'Admin',
          },
          {
            id: 'pay-points',
            title: 'Pay Points',
            icon: 'point_of_sale',
            type: 'item',
            url: '/backoffice/pay-points',
            priv: 'Admin',
          },
          {
            id: 'products',
            title: 'Products',
            icon: 'sell',
            type: 'item',
            url: '/backoffice/products',
            priv: 'Admin',
          },
          {
            id: 'product-categories',
            title: 'Product Categories',
            icon: 'style',
            type: 'item',
            url: '/backoffice/product-categories',
            priv: 'Admin',
          },
          {
            id: 'promotions',
            title: 'Promotions',
            icon: 'workspace_premium',
            type: 'item',
            url: '/backoffice/promotions',
            priv: 'Admin',
          },
          {
            id: 'resource-available-hours',
            title: 'Resource Availability',
            icon: 'pending_actions',
            type: 'item',
            url: '/backoffice/resource-available-hours',
            priv: 'Admin',
          },

          {
            id: 'resource_types',
            title: 'Resource Types',
            icon: 'category',
            type: 'item',
            url: '/backoffice/resourcetypes',
            priv: 'Admin',
          },
          {
            id: 'resource',
            title: 'Resources',
            icon: 'bed',
            type: 'item',
            url: '/backoffice/resources',
            priv: 'Admin',
          },
          {
            id: 'safety-policy',
            title: 'Safety Policies',
            icon: 'health_and_safety',
            type: 'item',
            url: '/backoffice/safety-policy',
            priv: 'Admin',
          },
          {
            id: 'void_reasons',
            title: 'Sale Reasons',
            icon: 'format_list_bulleted',
            type: 'item',
            url: '/backoffice/sale-reasons',
            priv: 'Admin',
          },
          {
            id: 'screening_questions',
            title: 'Screening Questions',
            icon: 'quiz',
            type: 'item',
            url: '/backoffice/screening-questions',
            priv: 'Admin',
          },
          {
            id: 'sessions',
            title: 'Sessions',
            icon: 'emoji_objects',
            type: 'item',
            url: '/backoffice/product-sessions',
            priv: 'Admin',
          },
          {
            id: 'session-categories',
            title: 'Session Categories',
            icon: 'batch_prediction',
            type: 'item',
            url: '/backoffice/session-categories',
            priv: 'Admin',
          },
          {
            id: 'skin_type',
            title: 'Skin Types',
            icon: 'pan_tool',
            type: 'item',
            url: '/backoffice/skintypes',
            priv: 'Admin',
          },
          {
            id: 'skin_type_resource_matrix',
            title: 'Skin Type Resource Matrix',
            icon: 'grid_on',
            type: 'item',
            url: '/backoffice/skin-type-resource-matrix',
            priv: 'Admin',
          },
          {
            id: 'stock',
            title: 'Stock',
            icon: 'inventory',
            type: 'collapse',
            priv: 'Admin',
            children: [
              {
                id: 'stock-input',
                title: 'Stock Input',
                icon: 'edit',
                type: 'item',
                url: '/backoffice/stockinput',
                priv: 'Admin',
              },
              {
                id: 'stock-check',
                title: 'Stock Check',
                icon: 'production_quantity_limits',
                type: 'item',
                url: '/backoffice/stockcheck',
                priv: 'Admin',
              },
            ],
          },
          {
            id: 'terminals',
            title: 'Terminals',
            icon: 'monetization_on',
            type: 'item',
            url: '/backoffice/terminals',
            priv: 'Admin',
          },
          {
            id: 'vouchers',
            title: 'Vouchers',
            icon: 'redeem',
            type: 'item',
            url: '/backoffice/vouchers',
            priv: 'Admin',
          },
        ],
      },
      {
        id: 'help',
        title: 'Help',
        type: 'item',
        icon: 'help',
        url: '/help',
        priv: 'user',
      },
    ],
  },
];
